import { Component, computed, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ActionConfig } from '../../model/dynamic-data-table.model';
import { LucideDynamicIcon, LucideRefreshCw } from '@lucide/angular';

@Component({
  selector: 'app-header-action-button',
  standalone: true,
  imports: [CommonModule, LucideDynamicIcon],
  templateUrl: './header-action-button.component.html',
  styleUrl: './header-action-button.component.scss'
})
export class HeaderActionButtonComponent {
  @Input() action: ActionConfig | null = null;
  @Output() buttonClicked = new EventEmitter<MouseEvent>();

  protected readonly refreshIcon = computed(() => LucideRefreshCw);

  isString(value: unknown): value is string {
    return typeof value === 'string';
  }

  onButtonClick(event: MouseEvent): void {
    if (this.action?.isLink && this.action.link) {
      if (globalThis.window !== undefined) {
        globalThis.window.open(this.action.link, '_blank', 'noopener,noreferrer');
      }
      return;
    }
    this.buttonClicked.emit(event);
  }
}
